<template>
  <div class="fileinput text-center">
    <div
      class="fileinput-new thumbnail"
      :class="{ 'img-circle': type === 'avatar' }"
      @click="clickSelectImgage"
      @dragover.prevent
      @dragenter.prevent
      @drop.prevent="onDrop"
    >
      <img :src="image" alt="preview" />
    </div>
    <div v-if="displayBtn">
      <span class="btn btn-primary btn-simple btn-file btn-sm">
        <span class="fileinput-new">
          {{ fileExists ? changeText : selectText }}
        </span>
        <input type="hidden" value="" name="" />
        <input
          accept="image/*"
          @change="handlePreview"
          type="file"
          name="..."
          class="valid"
          :multiple="false"
          aria-invalid="false"
          ref="selectImage"
        />
      </span>
      <!-- <base-button v-if="fileExists" @click="removeFile" round type="danger"> -->
      <base-button size="sm" class="btn btn-primary btn-simple" v-if="fileExists" @click="removeFile" type="danger">
        <i class="fas fa-times"></i> {{ removeText }}
      </base-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'image-upload',
  props: {
    type: {
      type: String,
      default: '',
      description: 'Image upload type (""|avatar)',
    },
    src: {
      type: String,
      default: '',
      description: 'Initial image to display',
    },
    selectText: {
      type: String,
      default: 'Select image',
    },
    changeText: {
      type: String,
      default: 'Change',
    },
    removeText: {
      type: String,
      default: 'Remove',
    },
    displayBtn: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    const avatarPlaceholder = '/img/placeholder.jpg'
    const imgPlaceholder = '/img/image_placeholder.jpg'
    return {
      placeholder: this.type === 'avatar' ? avatarPlaceholder : imgPlaceholder,
      imagePreview: null,
    }
  },
  computed: {
    fileExists () {
      return this.src !== '' || this.imagePreview !== null
    },
    image () {
      return this.src || this.imagePreview || this.placeholder
    },
  },
  methods: {
    handlePreview (event) {
      const file = event.target.files[0]
      if (file) {
        this.imagePreview = URL.createObjectURL(file)
        this.$emit('change', file)
      }
    },
    removeFile () {
      this.imagePreview = null
      this.$emit('change', null)
    },
    clickSelectImgage () {
      if (this.displayBtn) this.$refs.selectImage.click()
    },
    onDrop (event) {
      if (this.displayBtn) {
        const customEvent = {}
        customEvent.target = {}
        customEvent.target.files = [event.dataTransfer.files[0]]
        this.handlePreview(customEvent)
      }
    },
  },
}
</script>
<style></style>
